import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/node_modules/next-themes/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Fraunces\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-fraunces\"}],\"variableName\":\"fraunces\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Geist\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-geist\"}],\"variableName\":\"geist\"}");
;
import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["NotFoundLink"] */ "/app/node_modules/nextra-theme-docs/dist/components/404/index.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["Switchers"] */ "/app/node_modules/nextra-theme-docs/dist/components/footer/switchers.js");
;
import(/* webpackMode: "eager", webpackExports: ["LastUpdated"] */ "/app/node_modules/nextra-theme-docs/dist/components/last-updated.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/nextra-theme-docs/dist/components/locale-switch.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClientNavbar"] */ "/app/node_modules/nextra-theme-docs/dist/components/navbar/index.client.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/nextra-theme-docs/dist/components/sidebar.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/nextra-theme-docs/dist/components/theme-switch.js");
;
import(/* webpackMode: "eager", webpackExports: ["TOC"] */ "/app/node_modules/nextra-theme-docs/dist/components/toc.js");
;
import(/* webpackMode: "eager", webpackExports: ["HeadingAnchor"] */ "/app/node_modules/nextra-theme-docs/dist/mdx-components/heading-anchor.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClientWrapper"] */ "/app/node_modules/nextra-theme-docs/dist/mdx-components/wrapper.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["ConfigProvider","useConfig"] */ "/app/node_modules/nextra-theme-docs/dist/stores/config.js");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeConfigProvider","useThemeConfig"] */ "/app/node_modules/nextra-theme-docs/dist/stores/theme-config.js");
;
import(/* webpackMode: "eager", webpackExports: ["TOCProvider","useTOC"] */ "/app/node_modules/nextra-theme-docs/dist/stores/toc.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/nextra-theme-docs/dist/style.css");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/node_modules/nextra/dist/client/components/button.js");
;
import(/* webpackMode: "eager", webpackExports: ["ImageZoom"] */ "/app/node_modules/nextra/dist/client/components/image-zoom.js");
;
import(/* webpackMode: "eager", webpackExports: ["Search"] */ "/app/node_modules/nextra/dist/client/components/search.js");
;
import(/* webpackMode: "eager", webpackExports: ["Select"] */ "/app/node_modules/nextra/dist/client/components/select.js");
;
import(/* webpackMode: "eager", webpackExports: ["SkipNavLink"] */ "/app/node_modules/nextra/dist/client/components/skip-nav/index.client.js");
;
import(/* webpackMode: "eager", webpackExports: ["useCopy"] */ "/app/node_modules/nextra/dist/client/hooks/use-copy.js");
;
import(/* webpackMode: "eager", webpackExports: ["useFSRoute"] */ "/app/node_modules/nextra/dist/client/hooks/use-fs-route.js");
;
import(/* webpackMode: "eager", webpackExports: ["useHash"] */ "/app/node_modules/nextra/dist/client/hooks/use-hash.js");
;
import(/* webpackMode: "eager", webpackExports: ["useMounted"] */ "/app/node_modules/nextra/dist/client/hooks/use-mounted.js");
;
import(/* webpackMode: "eager", webpackExports: ["Details"] */ "/app/node_modules/nextra/dist/client/mdx-components/details.js");
;
import(/* webpackMode: "eager", webpackExports: ["CopyToClipboard"] */ "/app/node_modules/nextra/dist/client/mdx-components/pre/copy-to-clipboard.js");
;
import(/* webpackMode: "eager", webpackExports: ["ToggleWordWrapButton"] */ "/app/node_modules/nextra/dist/client/mdx-components/pre/toggle-word-wrap-button.js");
